import { tns } from "tiny-slider/src/tiny-slider"

'use strict'

const media = {
    init: function () {
        let el = document.querySelectorAll(".tiny-slider");
        for (let i = 0; i < el.length; i++) {
            var autoplay = el[i].getAttribute('data-customcontrol-autoplay')
            var controlsContainer = el[i].getAttribute('data-control-element')
            if (autoplay === "true") {
                var slider = tns({
                    container: el[i],
                    items: 1,
                    loop: true,
                    mode: 'carousel',
                    slideBy: 'page',
                    mouseDrag: true,
                    autoplay: true,
                    controlsContainer: controlsContainer,
                });
            }
            else {
                var slider = tns({
                    container: el[i],
                    items: 1,
                    loop: true,
                    mode: 'carousel',
                    slideBy: 'page',
                    mouseDrag: true,
                    controlsContainer: controlsContainer,
                });

                const stopVideos = function () {
                    var videoElements = document.getElementsByClassName("videoelement");

                    for (var i = 0; i < videoElements.length; i++) {
                        var video = videoElements[i];
                        video.pause();
                    }
                }

                slider.events.on('transitionStart', stopVideos);


            }
        }
    },
}

export default media.init()
